import type { Party } from '@/features/party/types';

import i18n from '../i18n/i18n';

/**
 * This *garbage* has been lifted ~straight from the broker-platform... I know...
 *
 * Returns the party name based on the fact if it is a CUSTOMER or a COMPANY by the party object.
 * @param party The party object where the name should be extracted from/
 * @returns Returns the name or localized "Unknown" if no name is available.
 */
export const getPartyName = (party: Maybe<Party>): string | undefined => {
  if (!party) return '';

  if (party.type === 'COMPANY') return party.name ?? i18n.t('UNKNOWN');

  if (party.type === 'CUSTOMER') {
    const { first_name, infix, last_name } = party;

    // Clean up null/undefined values and avoid literal "null" strings
    const cleanFirstName =
      first_name && first_name !== 'null' ? first_name : '';
    // const cleanInitials = initials && initials !== 'null' ? initials : '';
    const cleanInfix = infix && infix !== 'null' ? infix : '';
    const cleanLastName = last_name && last_name !== 'null' ? last_name : '';

    // Use first_name if available, otherwise fall back to initials
    // const displayName = cleanFirstName || cleanInitials;
    const displayName = cleanFirstName;

    // Check if infix is already part of the last name to avoid duplication
    const infixAlreadyInLastName =
      cleanInfix &&
      cleanLastName.toLowerCase().includes(cleanInfix.toLowerCase());

    const nameParts = infixAlreadyInLastName
      ? [displayName, cleanLastName]
      : [displayName, cleanInfix, cleanLastName];

    const fullName = nameParts.filter(Boolean).join(' ');

    // Return localized "Unknown" if no name parts are available
    return fullName;
  }

  return undefined;
};

export const getPartyAddress = (party: Party) => {
  if (!('address' in party)) return '';

  const addressParts: string[] = [];
  if (party.address?.street) addressParts.push(party.address?.street);
  if (party.address?.city) addressParts.push(party.address?.city);
  if (party.address?.zipcode) addressParts.push(party.address?.zipcode);

  const addressString = addressParts.join(', ');

  return addressString;
};

export const buildAnvaLink = (ref: string) => {
  const encodedRef = encodeURIComponent(ref);

  return `https://hub.anva.io/contacts/viewcontact/${encodedRef}/overzicht`;
};
